import React from "react";
import { IProgressBar, ProgressBarClass } from "../../interfaces/Components/ProgressBar/IProgressBar";
import { ProgressBarCalcMethodEnum } from "../../interfaces/Components/ProgressBar/RoundCalculation";

import "./ProgressBar.scss"

export const ProgressBar: React.FC<IProgressBar> = ({variant, min, now, max, progressCalcMethod}) => {
    const backgroundClass = `${ProgressBarClass[variant]}`;

    const ratioProgress = () => {        
        return `${now} of ${max}`;
    };

    const isCalcMethodRatio = () => {
        return progressCalcMethod === ProgressBarCalcMethodEnum.XOfY;
    }

    const calculateStyle = () => {
        return isCalcMethodRatio() === true ? `${(now/max)*100}%` : `${now}%`;
    };

    const getPercentage = () : number => {
        return Math.round((now / max) * 100);
    }

    return(
        <div className="progress position-relative" data-testid="progress-bar">
            <div role="progressbar"
                className= {`progress-bar ${backgroundClass}`} 
                aria-valuenow={now} 
                aria-valuemin={min} 
                aria-valuemax={max} 
                aria-label="Progress bar"
                style={{width: calculateStyle() }}>
            </div>
            
            <small data-testid="progress-bar-label" className="justify-content-center d-flex position-absolute w-100 label">                
                {isCalcMethodRatio() ? ratioProgress() : `${getPercentage()}%`}
            </small>
        </div>
    );
}
